<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import { Select } from "element-ui";
import config from "../../../../../../configHttp.js";
import { dkdj_fetchBillDetails } from "../../../../../api/dkdj.js";
import { syncDeductInvoiceInfo } from '@/api/iinv';
import bsdl from '@/components/common/bsdl/index.vue';
import { kydkpz_queryCompanyList } from '@/api/kydkpz';
import { deleteBatchAutoLog, queryGatewayInfo } from '@/api/organization';
export default {
  data: function () {
    return {
      shaidiag: false,
      headData: getdata().headData,
      outlist: [],
      searchdiag: false,
      searchlist: getdata().searchlist,
      dateValue: "",
      searchdata: getdata().searchdata,
      tableData: [],
      pagination: getdata().pagination,
      tablekey: 0,
      overlength: 0,
        logId: 0,
        options:[],
        companyCode: "",
        drawer: false,
        rpaFormData:{},
        dialogFormVisible: false,
        syncForm:getdata().syncForm,
        formLabelWidth: '120px',
    };
  },
  mounted() {},
  components: { bsdl },
  methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
      submitSync() {
          if (!this.syncForm.issueDate || this.syncForm.issueDate.length === 0) {
              this.$message.error("请选择开票日期")
              return;
          }
          this.syncForm.issueStart = this.syncForm.issueDate[0];
          this.syncForm.issueEnd = this.syncForm.issueDate[1];
          this.syncForm.step = 8; // 当前步骤
          let companyId = this.syncForm.companyId;
          syncDeductInvoiceInfo(this.syncForm).then(res => {
              if (res.data.code === "1"){
                  this.$message.success("已提交同步任务，请稍后再进行查询")
              } else if (res.data.code === "102") {
                  // 需要登录
                  this.$confirm('同步失败，RPA未登录，点击确认进行登录', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(() => {
                      queryGatewayInfo({companyId: companyId}).then(gatewayRes => {
                          if (gatewayRes.data.code === 1) {
                              this.logId = res.data.data;
                              this.rpaFormData = gatewayRes.data.data[0];
                              this.drawer = true;
                          }
                      })
                  }).catch(()=>{
                      deleteBatchAutoLog({id: res.data.data}).then(autoLogRes=>{})
                  });
              } else {
                  this.$message.error("提交任务失败，原因：" + res.data.msg);
              }
              this.closedialog();
          })
      },
      closedialog() {
          this.dialogFormVisible = false;
          this.syncForm = getdata().syncForm
      },
    closeshaidiag() {
      this.shaidiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    outPutIInvResult() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      let data = {};
      if (selectVal.length > 0) {
        data.ids = selectVal.map((item) => item.id);
      } else {
        data.searchExtendInputDTO = JSON.parse(JSON.stringify(this.searchdata));
      }
      let params = {
        downUrl: config.baseURL + "dkdj/details/export",
        typeObj: {
          toForm: false,
          fileName: "代扣代缴票据明细" + this.$timestampToStr(new Date(), "yyyyMMdd"),
          fileType: "xlsx",
          failUrl:this.$winURl
        },
        params: data,
      };
      this.$downloadcommon(params);
    },
    forRefresh() {
      this.fetchBillDetails();
    },
      syncData(){
        this.dialogFormVisible = true;
      },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.fetchBillDetails();
    },
      smsClose() {
          this.drawer = false;
      },
    fetchBillDetails() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = "";
      params.order = "";
      dkdj_fetchBillDetails(params).then((res) => {
        this.pagination.total = res.data.data.total;
        this.pagination.paginationkey++;
        this.tableData = res.data.data.records;
      });
        kydkpz_queryCompanyList().then(res => {
            if (res.data.code === 1) {
                let _data = res.data.data.map(v => {
                    return {
                        value: v.id,
                        label: v.nsrmc
                    };
                });
                this.options.push(..._data);
            } else {
                this.$message.error(res.data.msg);
            }
        });
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.fetchBillDetails();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.fetchBillDetails();
    },
  },
  created() {
    this.fetchBillDetails();
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
